export default "/images/frame.svg?80b4b3370cd4d68c39c0917187c3f808";